export default "__VITE_ASSET__DSWZK0U$__"